import { LoadingButton } from "@mui/lab";
import { Box, Dialog, Typography, Button, FormControl, Select, InputLabel, MenuItem } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
    open: boolean,
    title: string,
    loading: boolean,
    onCancel: VoidFunction,
    onConfirm: Function
}

const reasons: string[] = [
    "ບັນຫາດ້ານວິຊາການ",
    "ບໍ່ສາມາດຊອກຫາ ຫຼື ຕິດຕໍ່ລູກຄ້າໄດ້",
    "ບໍ່ມີຜູ້ຂົນສົ່ງ",
    "ລາຍການທີ່ຈັດສົ່ງໃຫ້ບໍ່ຖືກຕ້ອງ",
    "ລູກຄ້າຍົກເລີກ ເນື່ອງຈາກອໍເດີ້ລ່າຊ້າ",
    "ລາຍການບໍ່ມີ",
    "ລາຍການສັ່ງຖືກຍົກເລີກ",
    "ອໍເດີ້ບໍ່ໄດ້ຮັບຕາມເວລາ",
    "ອໍເດີ້ສໍາເລັດບາງສ່ວນ",
    "ປິດແລ້ວ",
]

const ConfirmCancelOrderDialog = ({ open, title, loading, onCancel, onConfirm }: Props) => {
    const [value, setValue] = useState<string>(reasons[0]);
    const { t } = useTranslation("global");

    return <Dialog
        open={open}
    >
        <Box sx={{ width: '350px', paddingTop: 4, paddingBottom: 5, height: '150px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box>
                <Typography variant='h6' sx={{ mb: 2 }}>{title}</Typography>
                <Typography sx={{ marginBottom: "5px" }}>{t("Decline reason")}</Typography>
                <FormControl fullWidth>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                    >
                        {
                            reasons?.map((item: string) => <MenuItem key={item} value={item}>{item}</MenuItem>)
                        }
                    </Select>
                </FormControl>
                <Box mt={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button variant='contained' color='error' onClick={onCancel} sx={{ textTransform: 'none', mr: 1, width: 100, height: 40 }}>
                        {t("No")}
                    </Button>
                    <Button variant='contained' color='secondary' disabled={loading} onClick={() => onConfirm(value)} sx={{ textTransform: 'none', color: '#fff', width: 100, height: 40 }}>
                        {
                            loading ?
                                <LoadingButton loading >
                                    Loading...
                                </LoadingButton>
                                : t("Yes")
                        }
                    </Button>
                </Box>
            </Box>
        </Box>
    </Dialog>
}
export default ConfirmCancelOrderDialog;